import { saveTypeUser } from '@data/localStorageSetter';
import URLS from '@/URLS';
import { insertMiniappStoreLogUtil } from '@hooks/useInsertMiniappStoreLog'; 
import { ObjectId } from 'bson';
 // Convert to regular function instead of hook
export const getConfigRedirect = async (valid, creds, appData, OrderTypeNewData, order_type, checkSalesType, subscribeSplashscreen,  hitAPI, updateMiniappConfirmId) => {
  const { config } = appData;

  if (!config || config === undefined || config === null || !valid) {
    console.log('session exp-----');
    return URLS.SESSION_EXPIRED;
  }

  const type = (OrderTypeNewData() || []).filter((e) => e.disabled);
  if (order_type.result.order_types.length === type.length) {
    return URLS.OUTLET_CLOSE;
  }

  if (creds.miniapp) {
    if (config.display_login) {
      return URLS.LOGIN;
    } else {
      saveTypeUser('guest');
      ///dari qrstore config tableID null
      ///direct langsung ke takeaway
      ///jika null ke normal biasanya kalo ada isinya baru force
      return checkSalesType();
    }
  } else {
    const id = new ObjectId().toString();
    updateMiniappConfirmId(id);

    // Hit API untuk insert miniapp storelog
    try {
      await insertMiniappStoreLogUtil(hitAPI, config.storeUUID, id);
    } catch (error) {
      console.error('Error inserting miniapp storelog:', error);
    }
    subscribeSplashscreen();

    return null; // Return null to indicate async operation is in progress
  }
};